export default {
  title: {
    id: 'product_page_express_replacement_modal_title',
    defaultMessage: 'Express Replacement',
  },
  section1Title: {
    id: 'product_page_express_replacement_modal_section1_title',
    defaultMessage: 'What’s Express Replacement?',
  },
  section1Text: {
    id: 'product_page_express_replacement_modal_section1_text',
    defaultMessage:
      'If you have any issues with the purchase, we’ll replace it with identical device. Then, send the original back once you receive your replacement so you’re never without a device.',
  },
  section2Title: {
    id: 'product_page_express_replacement_modal_section2_title',
    defaultMessage: 'How does it work?',
  },
  section2Item2Title: {
    id: 'product_page_express_replacement_modal_section2_item2_title',
    defaultMessage: 'Get your replacement device within a few days',
  },
  section2Item3Title: {
    id: 'product_page_express_replacement_modal_section2_item3_title',
    defaultMessage: 'GReturn the original ',
  },
}
